export const TOGGLE_CALENDAR_SYNC_REQUEST = 'TOGGLE_CALENDAR_SYNC_REQUEST';
export const TOGGLE_CALENDAR_SYNC_SUCCESS = 'TOGGLE_CALENDAR_SYNC_SUCCESS';
export const TOGGLE_CALENDAR_SYNC_FAILURE = 'TOGGLE_CALENDAR_SYNC_FAILURE';
